/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import _ from 'underscore';

const isPromise = val => (val != null) && (typeof(val.then) === 'function');

const timer = (typeof performance !== "undefined") && (typeof performance.now === 'function') ?
  performance
:
  Date;

// Redux store middlewares
export const Middleware = {
      promiseMiddleware(store) {
        return next => (function(action) {
          if (isPromise(action.payload)) {
            return action.payload.then(result => store.dispatch(_.extend({}, action, {payload: result})),
             error => store.dispatch(_.extend({}, action, {payload: error, error: true})));
          } 
            return next(action);
          
        });
      },

      // Thunk middleware
      thunkMiddleware(store) { return next => (function(action) {
        if (typeof(action) === 'function') {
          return action(store.dispatch, store.getState);
        } 
          return next(action);
        
      }); },

      // Debounce middleware, debounces on leading edge (more like a throttle?)
      debounceMiddleware(store) {
        const timers = {};

        return next => (function(action) {
          const debounce = action.meta != null ? action.meta.debounce : undefined;
          if (((debounce != null ? debounce.timeout : undefined) != null) && ((debounce != null ? debounce.key : undefined) != null)) {
            const {
              timeout
            } = debounce;
            const {
              key
            } = debounce;

            if (!timers[key]) {
              next(action);
              return timers[key] = setTimeout(
                () => timers[key] = null,
               timeout);
            }
          } else {
            return next(action);
          }
        });
      },

      loggerMiddleware(store) { return next => (function(action) {
        const logger = window.console;

        if (logger == null) { return next(action); }

        const started = timer.now();
        const prevState = store.getState();

        let error = null;
        let returnedValue = null;

        try {
          returnedValue = next(action);
        } catch (e) {
          error = e;
        }

        const took = timer.now() - started;
        const nextState = store.getState();

        const time = new Date();
        const title = `action ${action.type} ${time} in ${took.toFixed(2)} ms`;

        logger.group("%c%s", "color: #000000", title);
        logger.log("%c prev state", "color: #9E9E9E", prevState);
        logger.log("%c action", "color: #03A9F4", action);
        if (error) {
          logger.log("%c error", "color: #F20404", error);
        } else {
          logger.log("%c next state", "color: #4CAF50", nextState);
        }

        logger.groupEnd();

        if (error) { throw error; }
        return returnedValue;
      }); },

      // Utility function, returns true if running or built in development mode (either via process.env.NODE_ENV or window.LOCALIST_SETTINGS)
      isDevelopment() {
        let isDevelopment = false;

        // Prefer checking process.env.NODE_ENV, but fall back to value provided in LOCALIST_SETTINGS
        //
        // This uses try/catch, rather than conditional chanining process?.env?.NODE_ENV, since process.env.NODE_ENV
        // has some special handling in Webpack via DefinePlugin, and `process.env.NODE_ENV` gets replaced with the literal
        // value configured.
        //
        // Using optional chaining will always fail, because `process` isn't actually defined in webpack builds.
        //
        // When process isn't available (such as in asset pipeline builds), fall back to window.LOCALIST_SETTINGS.development,
        // finally assuming it's not development.
        try {
          isDevelopment = process.env.NODE_ENV === 'development';
        } catch (e) {
          isDevelopment = (window.LOCALIST_SETTINGS != null ? window.LOCALIST_SETTINGS.development : undefined) || false;
        }

        return isDevelopment;
      }
};